// Compare calendar dates as supplied by the API, without timezone conversion.
export function calendarDate(value) {
  if (typeof value !== 'string') return null;
  const iso = /^(\d{4})-(\d{2})-(\d{2})(?:T|\s|$)/.exec(value.trim());
  // The case API returns MM-DD-YYYY; also retain slash-separated US dates.
  const us = /^(\d{1,2})([-/])(\d{1,2})\2(\d{4})(?:\s|$)/.exec(value.trim());
  if (!iso && !us) return null;
  const [year, month, day] = iso
    ? iso.slice(1).map(Number)
    : [Number(us[4]), Number(us[1]), Number(us[3])];
  const date = new Date(Date.UTC(year, month - 1, day));
  if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return null;
  return year * 10000 + month * 100 + day;
}

export function renewalVersion(renewalCase) {
  const renewal = calendarDate(renewalCase?.renewalDate);
  const created = calendarDate(renewalCase?.createdAt);
  if (renewal === null || created === null) return null;
  return renewal < 20261201 && created < 20261002 ? 'legacy' : 'current';
}
